import $ from 'jquery';
// @ts-ignore
import CodeMirror from 'codemirror/lib/codemirror.js';
import 'codemirror/mode/xml/xml';
import 'codemirror/mode/twig/twig';
import 'codemirror/addon/mode/multiplex';
import 'codemirror/addon/fold/xml-fold';
import 'codemirror/addon/edit/matchtags';
const ELEMENT_SELECTOR = '.js__code-mirror-editor-source';
export class CodeMirrorEditor {
    static init($root = $('body')) {
        const $editors = $root.find(ELEMENT_SELECTOR);
        if (!$editors.length) {
            return;
        }
        $editors.each((index, element) => {
            const $element = $(element);
            const isInClosedAccordion = $element.closest('.js__code-mirror-accordion-content:not(.active)').length;
            const elementIsVisible = $element.is(':visible');
            if (isInClosedAccordion || !elementIsVisible) {
                return;
            }
            const $accordionContent = $element.closest('.js__code-mirror-accordion-content');
            const isInModal = $element.closest('.modal');
            setTimeout(() => {
                const editor = CodeMirror.fromTextArea(element, {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: { name: 'twig', base: 'text/html' },
                    matchTags: true,
                    readOnly: !!$element.attr('readonly'),
                });
                const maxSize = 2000;
                let currentSize = 20 * editor.lineCount();
                if (currentSize < 300) {
                    currentSize = 300;
                }
                editor.setSize(null, maxSize > currentSize ? currentSize : maxSize);
                editor.on('change', () => {
                    editor.save();
                    $(element).trigger('change');
                });
                $accordionContent.addClass('loaded');
            }, isInModal ? 500 : 0);
        });
    }
}
